// extracted by mini-css-extract-plugin
export default {"fileUploaded":"styles_fileUploaded__tS51J"};